import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RealEstateViewPage } from './realestate-view.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'realestate/:id',
    component: RealEstateViewPage,
    canActivate: [authGuard, hasRoleGuard(null, ['update_realestate'])]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RealEstateViewPageRoutingModule { }
